module.exports = __webpack_public_path__ + "static/media/portfolio1 (34).20e601b7.jpeg";